import React, { useState, useEffect } from "react"
import logoImage from "../assets/imgs/header_logo.svg"
import { Link, NavLink } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"

const Header = () => {
    const [scrollPosition, setScrollPosition] = useState(false)
    const handleScroll = () => {
        if(window.pageYOffset > 0) setScrollPosition(true)
        else setScrollPosition(false)
    }
  
    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true })
  
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <div className={`header ${scrollPosition && "header-scrolled"} fixed-top d-flex align-items-center`}>
            <div className="logoBack"></div>
            <div className="container d-flex align-items-center">
                <Link className="logo me-auto pb-0" to={"/"}>
                    <img src={logoImage} href="" />
                </Link>

                <nav id="navbar" class="navbar order-last order-lg-0">
                    <ul>
                        <li>
                            <NavLink to={"/"}>
                                Home
                            </NavLink>
                        </li>
                        <li class="dropdown">
                            <NavLink to={"/about"}>
                                <span>About</span> <FontAwesomeIcon className="ps-1" fontSize={10} icon={faChevronDown} />
                            </NavLink>
                            <ul>
                                <li>
                                    <NavLink to={"/about"}>
                                        About Us
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/founder"}>
                                        Meet our Founder
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/team"}>
                                        Our Team
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/news-updates"}>
                                        News & Updates
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/awards"}>
                                        Awards
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <NavLink to="/our-services">
                                <span>Services</span> <FontAwesomeIcon className="ps-1" fontSize={10} icon={faChevronDown} />
                            </NavLink>
                            <ul>
                                <li>
                                    <NavLink to={"/our-services"}>
                                        Our Services
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/consumer-services"}>
                                        Consumer Service
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/corporate-financing"}>
                                        Corporate Financing
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/marketing-services"}>
                                        Marketing Services
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={"/debt-collection-recovery"}>
                                        Debt Collection & Recovery
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <NavLink to={"/careers"}>
                                Careers
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={"/contact"}>
                                Contact
                            </NavLink>
                        </li>
                        <a className="p-0" href="tel:+97144903500">
                            <div class="get-started-btn scrollto pointer">
                                Consult Us
                            </div>
                        </a>
                    </ul>
                    <i class="bi bi-list mobile-nav-toggle"></i>
                </nav>
            </div>
        </div>
    )
}

export default Header